import { useQuery, useSubscription, useApolloClient } from '@apollo/react-hooks'
import React from 'react'
import { PRODUCTS_BY_CATEGORY, GET_BRAND_LOCATION } from '../graphql'
import { useConfig } from './../lib'

//on demand menu context
export const onDemandMenuContext = React.createContext()

//initial state
const initialState = {
   categories: [],
   allProductIds: [],
   isMenuLoading: true,
}

//reducer
const reducer = (state = initialState, { type, payload }) => {
   switch (type) {
      case 'SEED': {
         const ids = payload.menu
            .map(category => {
               return category.subcategories
                  .map(subcategory => subcategory.products)
                  .flat()
            })
            .flat()
         return { ...state, categories: payload.menu, allProductIds: ids }
      }
      case 'MENU_LOADING':
         return { ...state, isMenuLoading: payload }
      default:
         return state
   }
}

export const OnDemandMenuProvider = ({ children }) => {
   const [timeZone, setTimeZone] = React.useState('Asia/Calcutta')
   const apolloClient = useApolloClient()
   // const [menuError, setMenuError] = React.useState()
   const { brand, isConfigLoading, locationId } = useConfig()
   const [onDemandMenu, onDemandMenuDispatch] = React.useReducer(
      reducer,
      initialState
   )
   const { data, loading, error } = useQuery(GET_BRAND_LOCATION, {
      skip: !locationId,
      variables: {
         where: {
            brandId: { _eq: brand?.id },
            locationId: { _eq: locationId },
         },
      },
      onCompleted: data => {
         if (data?.brandLocations.length > 0 && !error) {
            setTimeZone(data?.brandLocations[0].location.timezone)
         }
      },
   })

   const date = React.useMemo(() => {
      return new Date(Date.now()).toLocaleString('en-US', {
         timeZone: timeZone,
      })
   }, [timeZone])

   const { error: menuError } = useQuery(PRODUCTS_BY_CATEGORY, {
      skip: isConfigLoading || !brand?.id,
      variables: {
         params: {
            brandId: brand?.id,
            date,
            locationId: locationId,
         },
      },
      onCompleted: data => {
         if (data?.onDemand_getMenuV2copy?.length) {
            const [res] = data.onDemand_getMenuV2copy
            const { menu } = res.data
            onDemandMenuDispatch({
               type: 'SEED',
               payload: { menu },
            })
            onDemandMenuDispatch({
               type: 'MENU_LOADING',
               payload: false,
            })
         }
      },
   })

   React.useEffect(() => {
      if (menuError) {
         onDemandMenuDispatch({
            type: 'MENU_LOADING',
            payload: false,
         })
         console.error(menuError)
      }
   }, [menuError])

   return (
      <onDemandMenuContext.Provider
         value={{ onDemandMenu, onDemandMenuDispatch }}
      >
         {children}
      </onDemandMenuContext.Provider>
   )
}
